import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class SplitButtonModel extends ButtonBase {
    label: string = 'Split';
    action: string = ACTION_STATUS.split;
    matIconName: string = '';
    colorClass: string = 'color-info-500';
}